module.exports = __webpack_public_path__ + "img/Simon-Montero-Bachur.58630a9f.jpg";